<template>
	<div class="">
		Home page
	</div>
</template>

<script>
export default {
	name: 'home'
}
</script>
